import { z } from 'zod';

export const moveCropRequestSchema = z.object({
  localPath: z.string(),
  subfolder: z.enum(['approved', 'rejected']),
});

export type IMoveCropRequest = z.infer<typeof moveCropRequestSchema>;
